import React, { useEffect } from 'react';
import { useAppDispatch } from '../store/hooks';
import { fetchGrades } from '../store/slices/gradesSlice';
import { useAuth } from '../context/AuthContext';
import { useSubscription } from '../context/SubscriptionContext';
import SubscriptionExpiredModal from './common/SubscriptionExpiredModal';

/**
 * AppInitializer - Centralized component for initializing Redux state and handling global subscription checks
 * This component handles all initialization logic when the app loads or user logs in.
 * Add new initialization logic here as needed.
 */
const AppInitializer: React.FC = () => {
  const dispatch = useAppDispatch();
  const { user } = useAuth();
  const { isExpired, status, trialEndsAt } = useSubscription();

  useEffect(() => {
    if (user?.schoolId?._id) {
      // Initialize grades for the school
      dispatch(fetchGrades(user.schoolId._id));
      
      // Add more initialization logic here as needed:
      // dispatch(fetchOtherData(user.schoolId._id));
      // dispatch(initializeSettings(user.schoolId._id));
    }
  }, [dispatch, user?.schoolId?._id]);

  // Determine if modal should be open
  // Open if expired, suspended, pending_payment, OR if trial ended (expired status + trialEndsAt exists)
  // The isExpired flag from context should handle most cases, but we can be explicit
  const showModal = isExpired || (status === 'expired') || (status === 'suspended') || (status === 'pending_payment');

  return (
    <SubscriptionExpiredModal open={!!showModal} />
  );
};

export default AppInitializer;

